import { MessageCircle } from "lucide-react";
import { waLink, DEFAULT_WA_MESSAGE } from "@/lib/whatsapp";

const WhatsAppFloat = () => (
  <a
    href={waLink(DEFAULT_WA_MESSAGE)}
    target="_blank"
    rel="noopener noreferrer"
    aria-label="Escríbenos por WhatsApp"
    className="group fixed bottom-6 right-6 z-50 flex items-center gap-3"
    data-testid="floating-whatsapp-button"
  >
    <span className="hidden rounded-full bg-white px-4 py-2 text-sm font-medium text-slate-700 shadow-lg transition-opacity group-hover:opacity-100 sm:block sm:opacity-0">
      Cotiza en 2 minutos
    </span>
    <span className="relative flex h-14 w-14 items-center justify-center">
      <span className="absolute inset-0 rounded-full bg-[#25D366] animate-pulse-ring" />
      <span className="relative flex h-14 w-14 items-center justify-center rounded-full bg-[#25D366] text-white shadow-lg transition-transform group-hover:scale-105">
        <MessageCircle size={26} fill="currentColor" />
      </span>
    </span>
  </a>
);

export default WhatsAppFloat;
